export const APP_NAME = "Agro";
export const TOKEN_HASH = 'user-token';
export const USER_HASH = 'user-token';
export const APP_HASH = 'user-token';

let notify = () => {};
export const notifier = (type, message) => notify(type, message)
export const setNotifier = (noti) => notify = noti;